import { isLocale } from '$i18n/i18n-util.js';

export const match = (param) => isLocale(param);
